// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class AvailabilityService {
   $http: any
   $timeout: any
   $window: any
   aiEnabled: any
   availabilities: any
   availabilityConfig: any
   data: any
   fire: any
   l10nService: any
   rtaLoaded: any
   showRtaForDbid: any
   startIndex: any
   translationService: any
   constructor(data: any, config: any, l10nService: any, $http: any, $window: any, $timeout: any, translationService: any, hooksService: any) {
      this.reset = this.reset.bind(this)
      this.processNew = this.processNew.bind(this)
      this.processUpdate = this.processUpdate.bind(this)
      this.rtaLocale = this.rtaLocale.bind(this)
      this.getAvailability = this.getAvailability.bind(this)
      this.getSingleDocRTA = this.getSingleDocRTA.bind(this)
      this.getResultsFeedRTA = this.getResultsFeedRTA.bind(this)
      this.saveRTA = this.saveRTA.bind(this)
      this.unsaveRTA = this.unsaveRTA.bind(this)
      this.getRTA = this.getRTA.bind(this)
      this.handleNewItems = this.handleNewItems.bind(this)
      this.updateAvailabilityFromCache = this.updateAvailabilityFromCache.bind(this)
      this.getFullTextLinkDisplayText = this.getFullTextLinkDisplayText.bind(this)
      this.formatAdditionalLink = this.formatAdditionalLink.bind(this)
      this.formatLinkResolver = this.formatLinkResolver.bind(this)
      this.getAvailabilityInfo = this.getAvailabilityInfo.bind(this)
      this.data = data
      this.l10nService = l10nService
      this.$http = $http
      this.$window = $window
      this.$timeout = $timeout
      this.translationService = translationService
      this.rtaLoaded = {}
      this.reset()
      this.availabilityConfig = config.data.availability
      this.aiEnabled = config.data.document.enableAIPage
      this.showRtaForDbid = config.data.results.showRtaForDbid
      this.data.on('new', this.processNew)
      this.data.on('update', this.processUpdate)
      hooksService.setHooks(this, 'AvailabilityService', ['update'], true)
   }

   reset() {
      if (!this.availabilities) { this.availabilities = {} }
      // keep the saved items
      const savedItemKeys = _.chain(this.availabilities).map(function(value: any, key: any) { if (value.saved) { return key } }).compact().value()
      this.availabilities = _.pick(this.availabilities, savedItemKeys)
      this.startIndex = 0
      return this.rtaLoaded.loaded = false
   }

   processNew() {
      this.reset()
      return this.getResultsFeedRTA()
   }

   processUpdate() {
      this.rtaLoaded.loaded = false
      return this.getResultsFeedRTA()
   }

   rtaLocale() {
      return this.l10nService.getStandardLocale().replace(/(-.*$)/,'')
   }

   getAvailability(id: any) {
      const availability = this.availabilities[id]
      if (availability) {
      // return null to indicate that availability id request failed or no availability status was returned
         return {
            availabilities: availability.availabilities || null,
            error: availability.error || false
         }
      } else {
         return {
            availabilities: null,
            error: false
         }
      }
   }

   getSingleDocRTA(doc: any, saved = false, cache = true) {
      return this.getRTA([doc], saved, cache)
   }

   getResultsFeedRTA() {
      let docs = this.data.data.search.documents
      const docsLength = docs ? docs.length : 0

      // only look at the latest docs
      docs = docs ? docs.slice(this.startIndex) : []
      this.startIndex = docsLength
      // give time for browser to render results
      return this.$timeout((() => this.getRTA(docs)), 50)
   }

   // this assumes that all availabilityIds start with the DBID and then a whitespace char
   checkIfRtaIsEnabledForAvailId(id: any) {
      if (!id) { return false }
      const dbid = id.replace(/(...)\s.+/, "$1")
      return this.showRtaForDbid[dbid]
   }

   getAvailabilityIDs(docs: any) {
      const ids = []
      for (var doc of docs) {
         if (doc.availability_id && this.checkIfRtaIsEnabledForAvailId(doc.availability_id)) {
            ids.push(doc.availability_id)
         }
         if (doc.peer_documents != null) {
            for (var peer_doc of doc.peer_documents) {
               if (this.checkIfRtaIsEnabledForAvailId(peer_doc.availability_id)) {
                  ids.push(peer_doc.availability_id) 
               }
            }
         }
      }
      return _.uniq(_.compact(ids))
   }

   saveRTA(doc: any) {
      if (this.availabilities[doc.availability_id]) { return this.availabilities[doc.availability_id].saved = true }
   }

   unsaveRTA(doc: any) {
      if (this.availabilities[doc.availability_id]) { return this.availabilities[doc.availability_id].saved = false }
   }

   getRTA(docs: any, saved = false, cache = true)  {
      const availabilityIds = this.getAvailabilityIDs(docs)
      if (availabilityIds.length === 0) {
      // quick exit, there are no ids, so we can just exit the getRTA and fire the update event and globally mark rta 
      //   as loaded. Useful for components such as quicklook that may be initialized after rta has been loaded.
         this.fire('update', availabilityIds)
         return this.rtaLoaded.loaded = true
      } else {
         const requestParams = {
            's.id': availabilityIds,
            'uilang': this.rtaLocale(),
            's.cache': cache || 'update'
         }
         const params = $.param(requestParams, true)
         const promise = this.$http.get(`/2.0.0/availability/${this.availabilityConfig.libHash}?${params}`, {cache})
         // handle RTA response
         return promise.then((response: any) => {
            const {
               data
            } = response
            // construct newItems object in the following format:
            // {
            //   'SomeAvailabilityID':
            //   {
            //     availabilities: [ {}, {} ],
            //     saved: true
            //   }
            // }
            const ids = _.pluck(data.availabilityItems, 'id')
            const availabilities = _.zip(_.pluck(data.availabilityItems, 'availabilities'), _.times(ids.length, () => saved))
            const avObjects = _.map(availabilities, (value: any) => _.object(['availabilities', 'saved'], value))
            const newItems = _.object(ids, avObjects)
            let missingItems = _.difference(availabilityIds, ids)

            // @ts-ignore FIXME
            missingItems = _.object(missingItems, _.times(missingItems.length, () => ({
               error: true,
               saved
            })))
            return this.handleNewItems(_.extend(newItems, missingItems), availabilityIds, cache)
         }
         , () => {
            const errItems = _.object(availabilityIds, _.times(availabilityIds.length, () => ({
               error: true,
               saved
            })))
            return this.handleNewItems(errItems, availabilityIds, cache)
         })
      }
   }

   handleNewItems(newItems: any, availabilityIds: any, cache: any) {
      if (cache) {  // don't overwrite availability entry if it already exists in availabilities object
         newItems = _.omit(newItems, _.keys(this.availabilities))
         _.extend(this.availabilities, newItems)
      } else { 
         newItems = _.extend(this.availabilities, newItems)
      }
      this.fire('update', availabilityIds)
      // globally mark rta as loaded. Useful for components such as quicklook that may be initialized after rta has been loaded.
      return this.rtaLoaded.loaded = true
   }

   updateAvailabilityFromCache(availabilityIds: any) {
      return this.fire('update', availabilityIds)
   }

   getFullTextLinkDisplayText(content_type: any) {
      let needle
      if ((needle = content_type.toLowerCase(), ["book", "book chapter", "book review", "case", "conference proceeding", "dissertation", "ebook", "journal", "journal article", "newsletter", "newspaper article", "paper", "report", "trade publication article", "ejournal", "government document", "magazine article"].includes(needle))) {
         return this.translationService.translations.FULL_TEXT_ONLINE
      }
    
      return this.translationService.translations.AVAILABLE_ONLINE
   }

   formatAdditionalLink(displayText: any, link: any, isIedlLink = false) {
      if ((link == null) || (typeof displayText !== 'string')) { return }

      let linkInfo = ""
      // Show the provider name only for IEDL links. Non-IEDL links should still appear in the More Options dropdown but without a provider name.
      if (link.provider_name && isIedlLink) {
         linkInfo = this.translationService.translate(link.provider_name)
      }

      link = link.link || ""
      const additionalLinkInfo = ""
    
      return { displayText, linkInfo, additionalLinkInfo, link }
   }

   formatLinkResolver(link: any) {
      if (typeof link !== 'string') { return }

      const displayText = this.translationService.translations.LINK_RESOLVER
      const directLink = true

      return { displayText, directLink, link }
   }

   getAvailabilityInfo(doc: any) {
      if (doc == null) { return }
      let type = ""
      let displayText = ""
      let linkInfo = ""
      const additionalLinkInfo = ""
      let provider = ""
      const callNumDeweys = []
      const callNumDeweysOnFail = []

      const getLinkInfoFromDatabase = (doc: any) => { 
      // TODO Determine if we can take the first database name, or (what I did) only take it when there is one, if there are more databases, we don't know the origin for the 'full text online' link
      // also not show library catalog source_type, it's not relevant really
         if ((doc.databases?.length === 1) && this.availabilityConfig.showDatabaseInfo) {
            if (!doc.databases[0].source_types.includes("Library Catalog")) {
               return doc.databases[0].name
            }
         }
      }
    
      // set default provider for all links
      // for now only show library as provider if there is only one library, which gives certainty that that libary is the provider 
      provider = (doc.libraries?.length === 1 ? doc.library : "") || getLinkInfoFromDatabase(doc) || ""  

      // special handling for full-text links   
      if (doc.has_fulltext && !doc.is_print && !((doc.availability_id != null) && (doc.content_type.toLowerCase() === "book"))) {
         type = "fulltext"
         if (doc.link_provider != null) { provider = doc.link_provider }
         linkInfo = provider
         displayText = this.getFullTextLinkDisplayText(doc.content_type)      
      } else { 
      // set call numbers regardless of type for all other links 
         if (doc.lc_call_numbers?.length) {
            if (this.availabilityConfig.showCallNums) { callNumDeweys.push(doc.lc_call_numbers[0]) }
            if (this.availabilityConfig.showCallNumsOnFail) { callNumDeweysOnFail.push(doc.lc_call_numbers[0]) }
         }
         if (doc.deweys?.length) {
            if (this.availabilityConfig.showDeweys) { callNumDeweys.push(doc.deweys[0]) }
            if (this.availabilityConfig.showDeweysOnFail) { callNumDeweysOnFail.push(doc.deweys[0]) }
         }
      
         // set attributes that are specific to other types
         if (doc.availability_id) {
            type = "rta"
            displayText = this.translationService.translations.CHECK_AVAILABILITY
         } else if (doc.is_a_i && this.aiEnabled && !doc.is_print) {
            type = "ai"
            displayText = this.translationService.translations.CITATION_ONLINE
         } else if (doc.library || doc.is_print) {
            type = "physical"
            displayText = this.translationService.translations.CHECK_AVAILABILITY
         } else { // default type and text
            type = "citation"
            displayText = this.translationService.translations.CITATION_ONLINE
         }
    

         // handle linkInfo for non-full-text links, shown on hover and used for screen readers
         linkInfo = displayText
         if (callNumDeweys?.length) { 
            linkInfo = linkInfo + ", " + callNumDeweys.join(" ")
         } else if (callNumDeweysOnFail?.length) {
            linkInfo = linkInfo + ", " + callNumDeweysOnFail.join(" ")
         }
      
         if (provider) {
            linkInfo = linkInfo + ", " + provider
         }
      }

      return [type, displayText, callNumDeweys.join(" "), callNumDeweysOnFail.join(" "), linkInfo, additionalLinkInfo, provider]
   }
}


AvailabilityService.$inject = ['dataService', 'configService', 'localizationService', '$http', '$window', '$timeout', 'translationService', 'hooksService']

angular.module('summonApp.services')
   .service('availabilityService', AvailabilityService)
